/* peri-pdp sticky-webview 20260925-1730 */
/* peri-pdp expand-scroll-top 20260827-1600 */
/* peri-pdp.js revert-modal 20260827-1557 */
(function () {
  function initHeroSliders(root) {
    root.querySelectorAll('[data-peri-hero-slider]').forEach(function (slider) {
      if (slider._periHeroSliderBound) return;
      slider._periHeroSliderBound = true;

      var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-peri-hero-slide]'));
      var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-peri-hero-dot]'));
      if (!slides.length) return;

      var index = 0;
      var swipeStartX = null;
      var swipeStartY = null;
      var swipeLocked = null; // 'x' | 'y' | null
      var swipePointerId = null;
      var swipeSurface = slider.querySelector('[data-peri-hero-slides]') || slider;
      var desktopMq = window.matchMedia('(min-width: 990px)');
      var isScrollMode = function () {
        return desktopMq.matches;
      };

      var updateDots = function (activeIndex) {
        dots.forEach(function (dot, i) {
          var active = i === activeIndex;
          dot.classList.toggle('is-selected', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      };

      var scrollToSlide = function (i, behavior) {
        var slide = slides[i];
        if (!slide) return;
        swipeSurface.scrollTo({
          left: slide.offsetLeft,
          behavior: behavior || 'smooth',
        });
      };

      var syncIndexFromScroll = function () {
        if (!isScrollMode()) return;
        var width = swipeSurface.clientWidth;
        if (!width) return;
        var next = Math.round(swipeSurface.scrollLeft / width);
        next = Math.max(0, Math.min(slides.length - 1, next));
        if (next === index) return;
        index = next;
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });
        updateDots(index);
      };

      var setIndex = function (next, scrollBehavior) {
        if (!slides.length) return;
        var total = slides.length;
        index = ((next % total) + total) % total;

        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          if (isScrollMode()) {
            slide.removeAttribute('hidden');
          } else if (active) {
            slide.removeAttribute('hidden');
          } else {
            slide.setAttribute('hidden', '');
          }
        });

        updateDots(index);

        if (isScrollMode()) {
          scrollToSlide(index, scrollBehavior || 'smooth');
        }
      };

      var applyLayoutMode = function () {
        if (isScrollMode()) {
          slides.forEach(function (slide) {
            slide.removeAttribute('hidden');
          });
          scrollToSlide(index, 'auto');
        } else {
          setIndex(index, 'auto');
        }
      };

      if (typeof desktopMq.addEventListener === 'function') {
        desktopMq.addEventListener('change', applyLayoutMode);
      } else if (typeof desktopMq.addListener === 'function') {
        desktopMq.addListener(applyLayoutMode);
      }

      swipeSurface.addEventListener(
        'scroll',
        function () {
          if (!isScrollMode()) return;
          window.clearTimeout(swipeSurface._periHeroScrollSync);
          swipeSurface._periHeroScrollSync = window.setTimeout(syncIndexFromScroll, 80);
        },
        { passive: true }
      );

      var autoplayMs = parseInt(slider.getAttribute('data-peri-hero-autoplay'), 10);
      if (isNaN(autoplayMs)) autoplayMs = 2500;
      var autoplayTimer = null;
      var autoplayPaused = false;
      var resetAutoplay = function () {};

      if (autoplayMs >= 500 && slides.length > 1) {
        var canAutoplay = function () {
          if (autoplayPaused) return false;
          if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
          return true;
        };

        var stopAutoplay = function () {
          if (autoplayTimer) {
            clearInterval(autoplayTimer);
            autoplayTimer = null;
          }
        };

        var startAutoplay = function () {
          stopAutoplay();
          if (!canAutoplay()) return;
          autoplayTimer = window.setInterval(function () {
            setIndex(index + 1);
          }, autoplayMs);
        };

        resetAutoplay = function () {
          stopAutoplay();
          startAutoplay();
        };

        slider.addEventListener('mouseenter', function () {
          autoplayPaused = true;
          stopAutoplay();
        });
        slider.addEventListener('mouseleave', function () {
          autoplayPaused = false;
          startAutoplay();
        });
        slider.addEventListener('focusin', function () {
          autoplayPaused = true;
          stopAutoplay();
        });
        slider.addEventListener('focusout', function () {
          if (!slider.contains(document.activeElement)) {
            autoplayPaused = false;
            startAutoplay();
          }
        });

        document.addEventListener('visibilitychange', function () {
          if (document.hidden) stopAutoplay();
          else startAutoplay();
        });

        if (typeof IntersectionObserver === 'function') {
          var heroAutoplayObserver = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) startAutoplay();
                else stopAutoplay();
              });
            },
            { threshold: 0.2 }
          );
          heroAutoplayObserver.observe(slider);
        } else {
          startAutoplay();
        }
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-index'), 10);
          if (!isNaN(i)) setIndex(i);
          resetAutoplay();
        });
      });

      slider.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          setIndex(index + 1);
          resetAutoplay();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          setIndex(index - 1);
          resetAutoplay();
        }
      });

      /* Swipe / drag — pointer events cover touch + mouse */
      var endSwipe = function (clientX) {
        if (swipeStartX == null) return;
        var dx = clientX - swipeStartX;
        var axis = swipeLocked;
        swipeStartX = null;
        swipeStartY = null;
        swipeLocked = null;
        swipePointerId = null;
        swipeSurface.classList.remove('is-swiping');
        if (axis === 'y') return;
        if (Math.abs(dx) < 36) return;
        setIndex(index + (dx < 0 ? 1 : -1));
        resetAutoplay();
      };

      swipeSurface.addEventListener('pointerdown', function (e) {
        if (isScrollMode()) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target && e.target.closest && e.target.closest('[data-peri-hero-dot]')) return;
        swipeStartX = e.clientX;
        swipeStartY = e.clientY;
        swipeLocked = null;
        swipePointerId = e.pointerId;
        try {
          swipeSurface.setPointerCapture(e.pointerId);
        } catch (err) {}
      });

      swipeSurface.addEventListener('pointermove', function (e) {
        if (isScrollMode()) return;
        if (swipePointerId == null || e.pointerId !== swipePointerId || swipeStartX == null) return;
        var dx = e.clientX - swipeStartX;
        var dy = e.clientY - swipeStartY;
        if (swipeLocked == null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
          swipeLocked = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
          if (swipeLocked === 'x') swipeSurface.classList.add('is-swiping');
        }
        if (swipeLocked === 'x' && e.cancelable) e.preventDefault();
      }, { passive: false });

      swipeSurface.addEventListener('pointerup', function (e) {
        if (swipePointerId == null || e.pointerId !== swipePointerId) return;
        endSwipe(e.clientX);
      });

      swipeSurface.addEventListener('pointercancel', function (e) {
        if (swipePointerId == null || e.pointerId !== swipePointerId) return;
        swipeStartX = null;
        swipeStartY = null;
        swipeLocked = null;
        swipePointerId = null;
        swipeSurface.classList.remove('is-swiping');
      });

      setIndex(0);
    });
  }

  function initCarousels(root) {
    root.querySelectorAll('[data-peri-carousel]').forEach(function (carousel) {
      if (carousel._periCarouselBound) return;
      carousel._periCarouselBound = true;
      var track = carousel.querySelector('[data-peri-carousel-track]');
      var prev = carousel.querySelector('[data-peri-carousel-prev]');
      var next = carousel.querySelector('[data-peri-carousel-next]');
      if (!track) return;
      var loop = carousel.hasAttribute('data-peri-carousel-loop');

      var slideAmount = function () {
        var card = track.querySelector('[data-peri-carousel-item]');
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 16;
        return card ? card.offsetWidth + gap : 316;
      };

      var maxScroll = function () {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      };

      var atStart = function () {
        return track.scrollLeft <= 4;
      };

      var atEnd = function () {
        return track.scrollLeft >= maxScroll() - 4;
      };

      var scrollBy = function (dir) {
        if (loop && dir < 0 && atStart()) {
          track.scrollTo({ left: maxScroll(), behavior: 'smooth' });
          return;
        }
        if (loop && dir > 0 && atEnd()) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }
        track.scrollBy({ left: dir * slideAmount(), behavior: 'smooth' });
      };

      var autoplayMs = parseInt(carousel.getAttribute('data-peri-carousel-autoplay'), 10);
      var resetAutoplay = function () {};

      if (prev) {
        prev.addEventListener('click', function () {
          scrollBy(-1);
          resetAutoplay();
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          scrollBy(1);
          resetAutoplay();
        });
      }

      if (autoplayMs >= 500) {
        var autoplayTimer = null;
        var autoplayPaused = false;

        var canAutoplay = function () {
          if (autoplayPaused) return false;
          if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
          return true;
        };

        var stopAutoplay = function () {
          if (autoplayTimer) {
            clearInterval(autoplayTimer);
            autoplayTimer = null;
          }
        };

        var startAutoplay = function () {
          stopAutoplay();
          if (!canAutoplay()) return;
          autoplayTimer = window.setInterval(function () {
            scrollBy(1);
          }, autoplayMs);
        };

        var resetAutoplay = function () {
          stopAutoplay();
          startAutoplay();
        };

        carousel.addEventListener('mouseenter', function () {
          autoplayPaused = true;
          stopAutoplay();
        });
        carousel.addEventListener('mouseleave', function () {
          autoplayPaused = false;
          startAutoplay();
        });
        carousel.addEventListener('focusin', function () {
          autoplayPaused = true;
          stopAutoplay();
        });
        carousel.addEventListener('focusout', function () {
          if (!carousel.contains(document.activeElement)) {
            autoplayPaused = false;
            startAutoplay();
          }
        });

        track.addEventListener(
          'scroll',
          function () {
            stopAutoplay();
            window.clearTimeout(track._periAutoplayScrollEnd);
            track._periAutoplayScrollEnd = window.setTimeout(resetAutoplay, autoplayMs);
          },
          { passive: true }
        );

        document.addEventListener('visibilitychange', function () {
          if (document.hidden) stopAutoplay();
          else startAutoplay();
        });

        if (typeof IntersectionObserver === 'function') {
          var autoplayObserver = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) startAutoplay();
                else stopAutoplay();
              });
            },
            { threshold: 0.15 }
          );
          autoplayObserver.observe(carousel);
        } else {
          startAutoplay();
        }
      }
    });
  }

  function initRecipeLightboxes(root) {
    root.querySelectorAll('[data-peri-recipes-carousel]').forEach(function (carousel) {
      if (carousel._periRecipeLightboxBound) return;
      carousel._periRecipeLightboxBound = true;

      var section = carousel.closest('.peri-pdp-recipes') || carousel.parentElement;
      var lightbox = section && section.querySelector('[data-peri-recipe-lightbox]');
      if (!lightbox) return;

      var dialog = lightbox.querySelector('[data-peri-recipe-lightbox-dialog]');
      var img = lightbox.querySelector('[data-peri-recipe-lightbox-image]');
      var titleEl = lightbox.querySelector('[data-peri-recipe-lightbox-title]');
      var metaEl = lightbox.querySelector('[data-peri-recipe-lightbox-meta]');
      var tagEl = lightbox.querySelector('[data-peri-recipe-lightbox-tag]');
      var cta = lightbox.querySelector('[data-peri-recipe-lightbox-cta]');
      var lastFocus = null;
      var pointerStart = null;

      function openFromCard(card) {
        if (!card) return;
        lastFocus = document.activeElement;
        if (img) {
          img.src = card.getAttribute('data-recipe-image') || '';
          img.alt = card.getAttribute('data-recipe-title') || '';
        }
        if (titleEl) titleEl.textContent = card.getAttribute('data-recipe-title') || '';
        if (metaEl) metaEl.textContent = card.getAttribute('data-recipe-meta') || '';
        if (tagEl) {
          var tag = card.getAttribute('data-recipe-tag') || '';
          tagEl.textContent = tag;
          tagEl.hidden = !tag;
        }
        lightbox.hidden = false;
        lightbox.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('peri-recipe-lightbox-open');
        if (dialog && typeof dialog.focus === 'function') dialog.focus();
      }

      function cardFromTarget(target) {
        var card = target.closest('[data-peri-recipe-card]');
        if (card && carousel.contains(card)) return card;
        var link = target.closest('.peri-pdp-card--recipe-link');
        if (!link || !carousel.contains(link)) return null;
        if (link.hasAttribute('data-recipe-title')) return link;
        var titleNode = link.querySelector('.peri-pdp__heading--card');
        var metaNode = link.querySelector('.peri-pdp-card__footer span');
        var tagNode = link.querySelector('.peri-pdp__tag');
        var imageNode = link.querySelector('.peri-pdp-card__image img');
        link.setAttribute('data-recipe-title', (titleNode && titleNode.textContent) || link.getAttribute('aria-label') || '');
        link.setAttribute('data-recipe-meta', (metaNode && metaNode.textContent) || '');
        link.setAttribute('data-recipe-tag', (tagNode && tagNode.textContent) || '');
        if (imageNode && imageNode.getAttribute('src')) {
          link.setAttribute('data-recipe-image', imageNode.getAttribute('src'));
        }
        return link;
      }

      function close() {
        if (lightbox.hidden) return;
        lightbox.hidden = true;
        lightbox.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('peri-recipe-lightbox-open');
        if (img) img.removeAttribute('src');
        if (lastFocus && typeof lastFocus.focus === 'function') {
          try { lastFocus.focus(); } catch (err) {}
        }
      }

      carousel.addEventListener('pointerdown', function (event) {
        var card = cardFromTarget(event.target);
        if (!card) {
          pointerStart = null;
          return;
        }
        pointerStart = { x: event.clientX, y: event.clientY, card: card };
      }, { passive: true });

      carousel.addEventListener('pointerup', function (event) {
        if (!pointerStart) return;
        var start = pointerStart;
        pointerStart = null;
        var dx = Math.abs(event.clientX - start.x);
        var dy = Math.abs(event.clientY - start.y);
        // Ignore swipe/drag on the carousel track.
        if (dx > 10 || dy > 10) return;
        var card = cardFromTarget(event.target);
        if (!card || card !== start.card) return;
        event.preventDefault();
        openFromCard(card);
      });

      carousel.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var card = cardFromTarget(event.target);
        if (!card) return;
        event.preventDefault();
        openFromCard(card);
      });

      carousel.addEventListener('click', function (event) {
        var link = event.target.closest('.peri-pdp-card--recipe-link');
        if (!link || !carousel.contains(link)) return;
        event.preventDefault();
        openFromCard(cardFromTarget(link));
      });

      lightbox.querySelectorAll('[data-peri-recipe-lightbox-close]').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          close();
        });
      });

      if (cta) {
        cta.addEventListener('click', function () {
          close();
        });
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !lightbox.hidden) close();
      });
    });
  }

  function sendPlanGA4(eventName, params) {
    var payload = Object.assign(
      {
        event_category: 'PeriPlanPicker',
        send_to: 'G-Y0VT2QGQW7'
      },
      params || {}
    );
    if (typeof gtag === 'function') {
      gtag('event', eventName, payload);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));
  }

  function parseShopifyJson(res) {
    return res.text().then(function (text) {
      var raw = String(text || '').replace(/^\uFEFF/, '').trim();
      if (!raw) return {};
      try {
        return JSON.parse(raw);
      } catch (err) {
        var match = String((err && err.message) || '').match(/position\s+(\d+)/i);
        if (match) {
          try { return JSON.parse(raw.slice(0, Number(match[1]))); } catch (ignored) {}
        }
        throw err;
      }
    });
  }

  function beginAddFlow() {
    if (window.KozlerCartDrawer && typeof window.KozlerCartDrawer.beginAdd === 'function') {
      try { window.KozlerCartDrawer.beginAdd(); } catch (e) {}
    }
  }

  function refreshCartDrawer() {
    if (!window.KozlerCartDrawer) {
      document.dispatchEvent(new CustomEvent('cart:updated'));
      return;
    }
    if (typeof window.KozlerCartDrawer.refresh === 'function') {
      try { window.KozlerCartDrawer.refresh(); } catch (e) {}
    }
    if (typeof window.KozlerCartDrawer.open === 'function') {
      try { window.KozlerCartDrawer.open(); } catch (e) {}
    }
  }

  var PERI_YEARLY_VARIANT_ID = 46369551319226; // $199 one-time (perimenopause-yearly)
  var PERI_QUARTERLY_VARIANT_ID = 46369551253690; // $149 one-time (perimenopause)
  var PERI_YEARLY_SUB_VARIANT_ID = 46188449071290;
  var PERI_QUARTERLY_SUB_VARIANT_ID = 46168871436474;

  function periOnetimeVariantId(variantId) {
    var id = parseInt(variantId, 10) || 0;
    if (id === PERI_YEARLY_SUB_VARIANT_ID) return PERI_YEARLY_VARIANT_ID;
    if (id === PERI_QUARTERLY_SUB_VARIANT_ID) return PERI_QUARTERLY_VARIANT_ID;
    return id;
  }

  function addNativeToCart(variantId) {
    var prev = window._bypassBundleChooser;
    window._bypassBundleChooser = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: periOnetimeVariantId(variantId), quantity: 1 }] })
    }).finally(function () {
      window._bypassBundleChooser = prev;
    });
  }

  function planVariantId(root, plan) {
    var yearlyId = periOnetimeVariantId(
      parseInt((root && root.getAttribute('data-yearly-variant-id')) || '', 10)
        || PERI_YEARLY_VARIANT_ID
    );
    var quarterlyId = periOnetimeVariantId(
      parseInt((root && root.getAttribute('data-quarterly-variant-id')) || '', 10)
        || PERI_QUARTERLY_VARIANT_ID
    );
    if (plan === 'yearly') return yearlyId;
    return quarterlyId;
  }

  function variantIdFromEl(el) {
    if (!el) return 0;
    var root = el.closest('[data-peri-plan-picker]') || el.closest('[data-peri-sticky-plan]') || el;
    // simple_atc sells one one-time variant and has no plans to resolve.
    if (root && root.getAttribute('data-checkout-mode') === 'simple_atc') {
      var simpleId = parseInt(
        el.getAttribute('data-peri-variant-id') || root.getAttribute('data-peri-variant-id') || '',
        10
      ) || 0;
      return periOnetimeVariantId(simpleId);
    }
    var plan = (root && root.getAttribute('data-plan')) || el.getAttribute('data-plan') || 'yearly';
    var fromPlan = planVariantId(root, plan);
    if (fromPlan) return fromPlan;
    var raw = el.getAttribute('data-peri-variant-id')
      || (el.closest('[data-peri-variant-id]') && el.closest('[data-peri-variant-id]').getAttribute('data-peri-variant-id'))
      || '';
    return periOnetimeVariantId(raw);
  }

  function handleNativeAtc(btn) {
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    var variantId = variantIdFromEl(btn);
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding...';
    beginAddFlow();

    addNativeToCart(variantId)
      .then(function (res) {
        if (!res.ok) {
          return parseShopifyJson(res).then(function (data) {
            throw new Error((data && data.description) || 'Failed to add to cart');
          });
        }
        return parseShopifyJson(res).catch(function () { return {}; });
      })
      .then(function () {
        refreshCartDrawer();
      })
      .catch(function (err) {
        refreshCartDrawer();
        var msg = (err && err.message) || '';
        if (msg && !/json|unexpected|abort|failed to fetch|network/i.test(msg)) {
          alert(msg);
        }
      })
      .finally(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = originalText;
        window.setTimeout(function () {
          if (window.KozlerCartDrawer && typeof window.KozlerCartDrawer.finishAdd === 'function') {
            try { window.KozlerCartDrawer.finishAdd(); } catch (e) {}
          }
        }, 800);
      });
  }

  function planCheckoutUrl(root, plan) {
    if (!root) return '';
    if (plan === 'yearly') {
      return root.getAttribute('data-yearly-checkout-url') || '';
    }
    return root.getAttribute('data-quarterly-checkout-url') || '';
  }

  function setPickerExpanded(root, expanded) {
    if (!root || root.getAttribute('data-checkout-mode') !== 'loop_trial') return;
    var panel = root.querySelector('[data-peri-plan-panel-wrap]');
    var expandBtn = root.querySelector('[data-peri-plan-expand]');
    var chevronDown = root.querySelector('.peri-plan-picker__expand-chevron--down');
    var chevronUp = root.querySelector('.peri-plan-picker__expand-chevron--up');
    root.classList.toggle('is-collapsed', !expanded);
    root.classList.toggle('is-expanded', !!expanded);
    if (panel) {
      // Never leave [hidden] on — browser UA [hidden]{display:none!important} blocks the panel.
      panel.removeAttribute('hidden');
      panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    }
    if (expandBtn) expandBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (chevronDown) {
      if (expanded) chevronDown.setAttribute('hidden', '');
      else chevronDown.removeAttribute('hidden');
    }
    if (chevronUp) {
      if (expanded) chevronUp.removeAttribute('hidden');
      else chevronUp.setAttribute('hidden', '');
    }

    // Mobile only: subtle scroll so the expand bar sits at the top of the viewport
    if (expanded && expandBtn && window.matchMedia('(max-width: 989px)').matches) {
      window.requestAnimationFrame(function () {
        var header = document.querySelector('.core-header-wrapper') || document.querySelector('header');
        var offset = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
        var top = expandBtn.getBoundingClientRect().top + window.pageYOffset - offset - 8;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    }
  }

  function applyPlanToPicker(root, plan) {
    if (!root) return;
    // simple_atc has no plan options — a global plan switch must not rewrite its
    // variant id (that would swap the $127 one-time SKU for the subscription SKU).
    if (root.getAttribute('data-checkout-mode') === 'simple_atc') return;
    var isYearly = plan === 'yearly';
    var checkoutLink = isYearly ? 'A' : 'B';
    var isLoop = root.getAttribute('data-checkout-mode') === 'loop_trial';

    root.setAttribute('data-plan', plan);
    var variantId = planVariantId(root, plan);
    if (variantId) root.setAttribute('data-peri-variant-id', String(variantId));

    root.querySelectorAll('[data-peri-plan-option]').forEach(function (btn) {
      var selected = btn.getAttribute('data-plan') === plan;
      btn.classList.toggle('is-selected', selected);
      if (btn.getAttribute('role') === 'radio') {
        btn.setAttribute('aria-checked', selected ? 'true' : 'false');
      }
      if (btn.getAttribute('role') === 'tab') {
        btn.setAttribute('aria-selected', selected ? 'true' : 'false');
      }
      if (btn.hasAttribute('aria-pressed')) {
        btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      }
    });

    root.querySelectorAll('[data-peri-plan-panel]').forEach(function (panel) {
      var match = panel.getAttribute('data-peri-plan-panel') === plan;
      panel.hidden = !match;
    });

    var body = root.querySelector('[data-peri-plan-v2-body]');
    if (body) body.setAttribute('data-plan', plan);

    var cta = root.querySelector('[data-peri-plan-cta]');
    if (cta) {
      cta.setAttribute('data-checkout-link', checkoutLink);
      if (variantId) cta.setAttribute('data-peri-variant-id', String(variantId));
      if (isLoop) {
        var url = planCheckoutUrl(root, plan);
        if (url) cta.setAttribute('href', url);
      } else {
        cta.removeAttribute('href');
      }
    }
  }

  /**
   * Currency apps wrap shop-currency amounts in <span> markup — including inside
   * HTML attribute values — so a `data-*` price can arrive as
   * `<span class="money conversion-bear-money">$199</span>`. Strip tags before
   * using a price as text, otherwise the markup shows up verbatim in the UI.
   */
  function cleanAttr(value) {
    return (value || '').replace(/<[^>]*>/g, '').trim();
  }

  function applyPlanToSticky(sticky, plan) {
    if (!sticky) return;
    // simple_atc sticky buys one fixed variant — no plans to swap in.
    if (sticky.getAttribute('data-checkout-mode') === 'simple_atc') return;
    var isYearly = plan === 'yearly';
    sticky.setAttribute('data-plan', plan);

    var priceEl = sticky.querySelector('[data-peri-sticky-price]');
    var compareEl = sticky.querySelector('[data-peri-sticky-compare]');
    var chipEl = sticky.querySelector('[data-peri-sticky-chip]');
    var termsEl = sticky.querySelector('[data-peri-sticky-terms]');
    var cta = sticky.querySelector('[data-peri-sticky-cta]');

    if (priceEl) {
      priceEl.textContent = cleanAttr(
        isYearly
          ? sticky.getAttribute('data-yearly-price')
          : sticky.getAttribute('data-quarterly-price')
      );
    }
    if (compareEl) {
      compareEl.textContent = cleanAttr(sticky.getAttribute('data-yearly-compare'));
      compareEl.hidden = !isYearly;
    }
    if (chipEl) {
      chipEl.textContent = cleanAttr(sticky.getAttribute('data-yearly-chip'));
      chipEl.hidden = !isYearly;
    }
    if (termsEl) {
      termsEl.textContent = isYearly
        ? sticky.getAttribute('data-yearly-terms') || ''
        : sticky.getAttribute('data-quarterly-terms') || '';
    }
    if (cta) {
      cta.setAttribute('data-checkout-link', isYearly ? 'A' : 'B');
      if (!sticky.hasAttribute('data-peri-sticky-trial')) {
        cta.removeAttribute('href');
      } else if (!cta.getAttribute('href')) {
        cta.setAttribute('href', '#peri-hero-atc');
      }
    }
  }

  function setGlobalPlan(plan, sourceRoot) {
    document.querySelectorAll('[data-peri-plan-picker]').forEach(function (picker) {
      if (sourceRoot && picker === sourceRoot) {
        applyPlanToPicker(picker, plan);
      } else if (!sourceRoot || picker !== sourceRoot) {
        applyPlanToPicker(picker, plan);
      }
    });
    var sticky = document.querySelector('[data-peri-sticky-plan]');
    if (sticky) applyPlanToSticky(sticky, plan);
  }

  function initPlanPickers() {
    var sticky = document.querySelector('[data-peri-sticky-plan]');
    var pickers = document.querySelectorAll('[data-peri-plan-picker]');
    if (!pickers.length && !sticky) return;

    pickers.forEach(function (picker) {
      var placement = picker.getAttribute('data-placement') || 'hero';
      var impressed = false;

      function fireImpression() {
        if (impressed) return;
        impressed = true;
        sendPlanGA4('peri_plan_impression', {
          placement: placement
        });
      }

      if (typeof IntersectionObserver === 'function') {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                fireImpression();
                observer.disconnect();
              }
            });
          },
          { threshold: 0.35 }
        );
        observer.observe(picker);
      } else {
        fireImpression();
      }

      var isLoop = picker.getAttribute('data-checkout-mode') === 'loop_trial';
      if (isLoop) {
        setPickerExpanded(picker, false);
        applyPlanToPicker(picker, picker.getAttribute('data-plan') || 'yearly');
        var expandBtn = picker.querySelector('[data-peri-plan-expand]');
        if (expandBtn && !expandBtn._periExpandBound) {
          expandBtn._periExpandBound = true;
          // Theme core-modal treats aria-controls as a dialog trigger and
          // moves accordion markup into CORE-MODAL-PORTAL — strip that hook.
          expandBtn.removeAttribute('aria-controls');
          expandBtn.removeAttribute('aria-haspopup');
          expandBtn.setAttribute('data-core-modal-ignore', '');
          expandBtn.addEventListener(
            'click',
            function (event) {
              event.preventDefault();
              event.stopPropagation();
              event.stopImmediatePropagation();
              var next = picker.classList.contains('is-collapsed');
              setPickerExpanded(picker, next);
              sendPlanGA4(next ? 'peri_plan_expand' : 'peri_plan_collapse', {
                placement: placement,
                plan: picker.getAttribute('data-plan') || 'yearly'
              });
            },
            true
          );
        }
      }

      picker.querySelectorAll('[data-peri-plan-option]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var plan = btn.getAttribute('data-plan') || 'yearly';
          applyPlanToPicker(picker, plan);
          if (sticky) applyPlanToSticky(sticky, plan);
          document.querySelectorAll('[data-peri-plan-picker]').forEach(function (other) {
            if (other !== picker) applyPlanToPicker(other, plan);
          });
          sendPlanGA4('peri_plan_select', {
            placement: placement,
            plan: plan
          });
        });
      });

      var cta = picker.querySelector('[data-peri-plan-cta]');
      if (cta) {
        cta.addEventListener('click', function (event) {
          var plan = picker.getAttribute('data-plan') || 'yearly';
          sendPlanGA4('peri_plan_add_to_cart', {
            placement: placement,
            plan: plan
          });
          if (isLoop) {
            // Navigate to Loop checkout via href; do not preventDefault.
            return;
          }
          event.preventDefault();
          handleNativeAtc(cta);
        });
      }
    });

    if (sticky) {
      var stickyCta = sticky.querySelector('[data-peri-sticky-cta]');
      if (stickyCta) {
        var runStickyCta = function (event) {
          if (event) {
            if (event.cancelable) event.preventDefault();
            event.stopPropagation();
          }
          var plan = sticky.getAttribute('data-plan') || 'yearly';
          // One-time pages have no plan picker to scroll to — the sticky CTA buys directly.
          if (sticky.getAttribute('data-checkout-mode') === 'simple_atc') {
            sendPlanGA4('peri_plan_add_to_cart', {
              placement: 'sticky',
              plan: 'one_time'
            });
            handleNativeAtc(stickyCta);
            return;
          }
          sendPlanGA4('peri_plan_scroll_to_picker', {
            placement: 'sticky',
            plan: plan
          });
          scrollToHeroPriceChooser();
        };
        // Instagram Android WebView often drops click; mirror WLR touchend activation.
        var lastStickyTouch = 0;
        stickyCta.addEventListener(
          'click',
          function (event) {
            if (Date.now() - lastStickyTouch < 700) {
              if (event.cancelable) event.preventDefault();
              event.stopPropagation();
              return;
            }
            runStickyCta(event);
          },
          true
        );
        stickyCta.addEventListener(
          'touchend',
          function (event) {
            lastStickyTouch = Date.now();
            runStickyCta(event);
          },
          { passive: false, capture: true }
        );
      }

      var stickyImpressed = false;
      var stickyShowObserver = new MutationObserver(function () {
        if (stickyImpressed) return;
        if (!sticky.classList.contains('peri-pdp-sticky--hidden')) {
          stickyImpressed = true;
          sendPlanGA4('peri_plan_impression', {
            placement: 'sticky'
          });
        }
      });
      stickyShowObserver.observe(sticky, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function periHeaderOffset() {
    var header = document.querySelector('.core-header-wrapper') || document.querySelector('header');
    return header ? Math.ceil(header.getBoundingClientRect().height) : 80;
  }

  function scrollToHeroPriceChooser() {
    var target = document.getElementById('peri-hero-atc');
    if (!target) return false;
    var picker = target.querySelector('[data-peri-plan-picker]');
    if (picker && picker.getAttribute('data-checkout-mode') === 'loop_trial') {
      setPickerExpanded(picker, true);
    }
    // Mobile expand already scrolls the CTA bar to the top; desktop keeps center
    if (!window.matchMedia('(max-width: 989px)').matches) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    var chooser = target.querySelector('[data-peri-plan-option].is-selected')
      || target.querySelector('[data-peri-plan-expand]')
      || target.querySelector('[data-peri-plan-option]')
      || target.querySelector('[data-peri-plan-cta]');
    if (chooser && typeof chooser.focus === 'function') {
      window.setTimeout(function () {
        try { chooser.focus(); } catch (e) {}
      }, 320);
    }
    return true;
  }

  function scrollToPeriBeforeAfter() {
    var target = document.getElementById('peri-before-after');
    if (!target) return false;
    var top = target.getBoundingClientRect().top + window.pageYOffset - periHeaderOffset() - 8;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  }

  function initAtcLinks(root) {
    root.querySelectorAll('[data-peri-atc-trigger]').forEach(function (btn) {
      if (btn.getAttribute('data-peri-atc-bound')) return;
      btn.setAttribute('data-peri-atc-bound', '1');
      btn.addEventListener('click', function (e) {
        if (!scrollToHeroPriceChooser()) return;
        e.preventDefault();
      });
    });
  }

  function initReviewScroll(root) {
    root.querySelectorAll('[data-peri-reviews-scroll]').forEach(function (link) {
      if (link.getAttribute('data-peri-reviews-bound')) return;
      link.setAttribute('data-peri-reviews-bound', '1');
      link.addEventListener('click', function (e) {
        if (!scrollToPeriBeforeAfter()) return;
        e.preventDefault();
      });
    });
  }

  function markVipSuccess() {
    var heroRoot = document.querySelector('[data-peri-hero-vip]');
    if (heroRoot) {
      var heroForm = heroRoot.querySelector('[data-peri-hero-vip-form]');
      var heroField = heroRoot.querySelector('[data-peri-hero-vip-field]');
      var heroErrorIcon = heroRoot.querySelector('[data-peri-hero-vip-error-icon]');
      var heroSuccess = heroRoot.querySelector('[data-peri-hero-vip-success]');
      if (heroForm) heroForm.hidden = true;
      if (heroField) heroField.classList.remove('is-error');
      if (heroErrorIcon) heroErrorIcon.hidden = true;
      if (heroSuccess) heroSuccess.hidden = false;
      heroRoot.classList.add('is-success');
    }

    var sticky = document.querySelector('[data-peri-sticky]');
    if (sticky) {
      var stickyField = sticky.querySelector('[data-peri-sticky-field]');
      var stickyErrorIcon = sticky.querySelector('[data-peri-sticky-error-icon]');
      var stickyCompact = sticky.querySelector('[data-peri-sticky-success]');
      if (stickyField) stickyField.classList.remove('is-error');
      if (stickyErrorIcon) stickyErrorIcon.hidden = true;
      // Unlock teaser is a sticky collapse state — not VIP join success.
      // After join, hide sticky entirely (hero/capture show real success).
      if (stickyCompact) stickyCompact.hidden = true;
      sticky.classList.add('is-success');
      sticky.classList.add('peri-pdp-sticky--hidden');
      sticky.setAttribute('aria-hidden', 'true');
    }

    var vipCapture = document.querySelector('[data-peri-vip-capture]');
    if (vipCapture) {
      var captureForm = vipCapture.querySelector('[data-peri-vip-capture-form]');
      var captureSuccess = vipCapture.querySelector('[data-peri-vip-capture-success]');
      if (captureForm) captureForm.hidden = true;
      if (captureSuccess) captureSuccess.hidden = false;
      vipCapture.classList.add('is-success');
    }

    try {
      sessionStorage.setItem('periVipJoined', '1');
    } catch (err) {}
  }

  function initStickyCta() {
    var sticky = document.querySelector('[data-peri-sticky]');
    if (!sticky) return;
    markInAppViewport();
    // Always hoist to <body> so position:fixed isn't trapped by transformed
    // ancestors (common in theme wrappers / Instagram Android WebView).
    if (sticky.parentNode !== document.body) {
      document.body.appendChild(sticky);
    }

    var isQuizSticky = sticky.hasAttribute('data-quiz-sticky');
    var isInApp = document.documentElement.classList.contains('is-ig-inapp');
    var ctaAnchor = document.querySelector('[data-peri-hero-cta-anchor]');
    var heroSection =
      document.querySelector('#shopify-section-peri_hero') ||
      document.querySelector('.shopify-section.peri-section-hero') ||
      document.querySelector('.peri-section-hero') ||
      document.querySelector('.peri-pdp-hero') ||
      document.querySelector('[id*="__peri_hero"]') ||
      (ctaAnchor && ctaAnchor.closest('.shopify-section'));

    var vipCapture = document.querySelector('[data-peri-vip-capture]');
    var footers = Array.prototype.slice.call(
      document.querySelectorAll(
        'footer, [id*="__core-footer"], [data-quiz-endbar], [data-peri-sticky-hide]'
      )
    );

    var heroInView = true;
    var ctaInView = true;
    var vipCaptureInView = false;
    var firstGlanceDismissed = false;
    var FIRST_GLANCE_SCROLL_PX = 48;
    var HERO_PAST_PX = 64;

    // Collapse/minimize removed — always keep full sticky CTA bar (no price).
    sticky.classList.remove('is-collapsed');
    try {
      sessionStorage.removeItem('periStickyCollapsed');
    } catch (err) {}

    function markInAppViewport() {
      var ua = navigator.userAgent || '';
      if (!/Instagram|FBAN|FBAV|FB_IAB|FBIOS|Line\/|TikTok|Bytedance|musical_ly|Snapchat|Pinterest|Twitter|LinkedInApp|; wv\)|WebView/i.test(ua)) {
        return;
      }
      document.documentElement.classList.add('is-ig-inapp');
      document.documentElement.style.setProperty('--pq-inapp-lift', '20px');
    }

    function visibleBottom() {
      var inner = window.innerHeight || document.documentElement.clientHeight || 0;
      var vv = window.visualViewport;
      // Some Android WebViews report a bogus visualViewport height — never
      // let it *expand* the viewport used for sticky show/hide.
      if (vv && vv.height > 0) {
        var bottom = vv.height + (vv.offsetTop || 0);
        return inner > 0 ? Math.min(inner, bottom) : bottom;
      }
      return inner;
    }

    function isElementInView(el) {
      if (!el || !el.isConnected) return false;
      var rect = el.getBoundingClientRect();
      return rect.top < visibleBottom() && rect.bottom > 0;
    }

    function isFooterInView() {
      for (var i = 0; i < footers.length; i++) {
        var el = footers[i];
        if (!el || !el.isConnected) continue;
        if (el.offsetHeight === 0 && !el.getClientRects().length) continue;
        if (isElementInView(el)) return true;
      }
      return false;
    }

    function applyStickyVisible(visible) {
      sticky.classList.toggle('peri-pdp-sticky--hidden', !visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      // Inline overrides: Instagram Android WebView can leave opacity/visibility
      // stuck after class toggles, which also drops the CTA from the a11y tree.
      if (visible) {
        sticky.style.visibility = 'visible';
        sticky.style.opacity = '1';
        sticky.style.transform = 'translate3d(0,0,0)';
        sticky.style.pointerEvents = 'none';
        sticky.style.webkitTransform = 'translate3d(0,0,0)';
      } else {
        sticky.style.visibility = '';
        sticky.style.opacity = '';
        sticky.style.transform = '';
        sticky.style.pointerEvents = '';
        sticky.style.webkitTransform = '';
      }
      var stickyCta = sticky.querySelector('[data-peri-sticky-cta]');
      if (stickyCta) {
        stickyCta.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (visible) {
          stickyCta.removeAttribute('tabindex');
        } else {
          stickyCta.setAttribute('tabindex', '-1');
        }
      }
    }

    function syncStickyVisibility() {
      var visible;

      if (isQuizSticky) {
        // Page quiz sticky: keep existing first-glance + mid-page behaviour.
        var scrollY = window.scrollY || window.pageYOffset || 0;
        if (scrollY > FIRST_GLANCE_SCROLL_PX) {
          firstGlanceDismissed = true;
        } else if (scrollY <= 8) {
          firstGlanceDismissed = false;
        }
        var atFirstGlance = !firstGlanceDismissed && scrollY <= FIRST_GLANCE_SCROLL_PX;
        var midPageVisible = !heroInView && !vipCaptureInView && !isFooterInView();
        visible = atFirstGlance || midPageVisible;
      } else {
        // Product PDP sticky: only after the main hero has scrolled past.
        visible = !heroInView && !vipCaptureInView && !isFooterInView();
      }

      applyStickyVisible(visible);
    }

    function updateHeroInView(rect, isIntersecting) {
      // Prefer geometry over IO's isIntersecting — Android WebView IO can lag
      // or stay true after programmatic / accessibility scrolls (Maestro).
      if (rect && typeof rect.bottom === 'number') {
        heroInView = rect.bottom > HERO_PAST_PX && rect.top < visibleBottom();
        return;
      }
      if (typeof isIntersecting === 'boolean') {
        heroInView = isIntersecting;
      }
    }

    function updateCtaInView(rect, isIntersecting) {
      if (rect && typeof rect.bottom === 'number') {
        ctaInView = rect.bottom > 0 && rect.top < visibleBottom();
        return;
      }
      if (typeof isIntersecting === 'boolean') {
        ctaInView = isIntersecting;
      }
    }

    // Prefer the compact CTA / hero block — full section height can stay
    // "intersecting" for a long time on tall mobile PDPs.
    var heroObserveTarget = ctaAnchor || heroSection;
    if (typeof IntersectionObserver === 'function') {
      if (heroObserveTarget) {
        var heroObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            updateHeroInView(entry.boundingClientRect, entry.isIntersecting);
            syncStickyVisibility();
          });
        }, { threshold: [0, 0.01, 0.1], rootMargin: '0px' });
        heroObserver.observe(heroObserveTarget);
      }

      if (ctaAnchor && ctaAnchor !== heroObserveTarget) {
        var ctaObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            updateCtaInView(entry.boundingClientRect, entry.isIntersecting);
            syncStickyVisibility();
          });
        }, { threshold: 0, rootMargin: '0px' });
        ctaObserver.observe(ctaAnchor);
      }

      if (vipCapture) {
        var vipObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            vipCaptureInView = entry.isIntersecting;
            syncStickyVisibility();
          });
        }, { threshold: 0, rootMargin: '0px' });
        vipObserver.observe(vipCapture);
      }

      if (footers.length) {
        var footerObserver = new IntersectionObserver(function () {
          syncStickyVisibility();
        }, { threshold: [0, 0.01, 0.1], rootMargin: '0px' });

        footers.forEach(function (el) {
          try { footerObserver.observe(el); } catch (e) {}
        });
      }
    }

    function onViewportChange() {
      if (heroObserveTarget) {
        try {
          updateHeroInView(heroObserveTarget.getBoundingClientRect());
        } catch (e) {}
      }
      if (ctaAnchor) {
        try {
          updateCtaInView(ctaAnchor.getBoundingClientRect());
        } catch (e) {}
      }
      if (vipCapture) vipCaptureInView = isElementInView(vipCapture);
      syncStickyVisibility();
    }

    window.addEventListener('scroll', onViewportChange, { passive: true, capture: true });
    window.addEventListener('resize', onViewportChange, { passive: true });
    window.addEventListener('orientationchange', onViewportChange, { passive: true });
    document.addEventListener('touchmove', onViewportChange, { passive: true });
    document.addEventListener('touchend', onViewportChange, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', onViewportChange);
      window.visualViewport.addEventListener('scroll', onViewportChange);
    }

    // Maestro / TalkBack scrolls often skip window scroll + IO callbacks in
    // Android WebView. Poll geometry while the sticky module is alive.
    if (isInApp || /Android/i.test(navigator.userAgent || '')) {
      var pollCount = 0;
      var pollId = window.setInterval(function () {
        pollCount += 1;
        onViewportChange();
        // Keep polling — in-app sessions are short, and sticky must track scroll.
        if (pollCount > 600) {
          // ~5 min at 500ms; stop to avoid orphan timers on SPA navigations.
          window.clearInterval(pollId);
        }
      }, 500);
    }

    try {
      if (heroObserveTarget) updateHeroInView(heroObserveTarget.getBoundingClientRect());
      if (ctaAnchor) updateCtaInView(ctaAnchor.getBoundingClientRect());
      if (vipCapture) vipCaptureInView = isElementInView(vipCapture);
    } catch (e) {}

    syncStickyVisibility();
  }

  function initHeroCopyAb() {
    // Hero copy A/B removed — always B. Keep a no-op so older callers stay safe.
  }

  function initCoachToggles() {
    document.querySelectorAll('[data-peri-coach-toggle]').forEach(function (btn) {
      if (btn._periCoachBound) return;
      btn._periCoachBound = true;
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-peri-coach-card]');
        if (!card) return;
        var expanded = card.classList.toggle('is-expanded');
        card.classList.toggle('is-collapsed', !expanded);
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        var label = btn.querySelector('[data-peri-coach-toggle-label]');
        if (label) label.textContent = expanded ? 'See Less' : 'Read More';
        var chevron = btn.querySelector('[data-peri-coach-chevron]');
        if (chevron) {
          // Starts as down arrow; rotate 180° when expanded (points up)
          chevron.style.transform = expanded ? 'rotate(180deg)' : 'rotate(0deg)';
        }
      });
    });
  }

  window.PeriPdp = window.PeriPdp || {};
  window.PeriPdp.initCoachToggles = initCoachToggles;

  function init() {
    if (window.__periPdpInitialized) return;
    window.__periPdpInitialized = true;

    initCarousels(document);
    initHeroSliders(document);
    initRecipeLightboxes(document);
    initPlanPickers();
    initHeroCopyAb();
    initCoachToggles();
    initAtcLinks(document);
    initReviewScroll(document);
    initStickyCta();
    if (window.location.hash === '#peri-before-after') {
      window.requestAnimationFrame(scrollToPeriBeforeAfter);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
